import { css } from '@emotion/react';

export default () => css`
  .react-flow__node-default {
    padding: 0px;
    border: none;
  }

  .blockly-editor {
    width: 100%;
    height: 50vh;
    min-height: 300px;
  }

  /* Hace que el div de inyección use el alto del contenedor, no el viewport */
  .blockly-editor > .injectionDiv {
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
  }

  /* Expande el SVG dentro del injectionDiv */
  .blockly-editor > .injectionDiv .blocklySvg {
    width: 100% !important;
    height: 100% !important;
  }
`;
